// extracted by mini-css-extract-plugin
module.exports = {"container":"IconBlockContainer__container___euVWS"};